import React from "react";
import axios from 'axios';
import GlobalUtil from '../../utils/GlobalUtil';
import CaptureAnalytics from '../../analytics/CaptureAnalytics';

class LibraryManager {

    sendActivationAnalytic(type) {
		const captureAnalytics = new CaptureAnalytics(window.ENV);
        captureAnalytics.initAnalytics();
        let eventObj;
		switch (type) {
            case 'libsfetch':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Libraries Fetch',
                    type: 'api-error',
                    subType: 'dialog'
                };
                break;
            case 'libcreated':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Default Library Created',
                    type: 'api-error',
                    subType: 'dialog'
                };
                break;
            case 'assetpost':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Asset Post',
                    type: 'api-error',
                    subType: 'dialog'
                };
                break;
        }
        captureAnalytics.genericAnalyticEvent(eventObj);
	}


    getLibraries = (start = 0, dispatch, dispatchLibsFetched) => {
        if (window.adobeIMS.isSignedInUser() === undefined) {
            return;
        }
        let libUrl = window.CONFIG_QA.servers.melville;
        let accessToken = "Bearer " + window.adobeIMS.getAccessToken();
        const header = {
            'Authorization': accessToken,
            'x-api-key': 'CCHomeWeb1'
        }
        libUrl = libUrl + `?orderBy=name&start=${start}&limit=10&owner=all&selector=default&toolkit=none`;
        axios.get(libUrl, {
            headers: header
        }).then(resp => {
            if (resp.data.libraries.length === 0) {
                this.createLibrary("Your Library", dispatch, dispatchLibsFetched);
            }
            else {
                dispatch(resp);
                if (start+resp.data.libraries.length < resp.data.total_count) {
                    this.getLibraries(start+10, dispatch, dispatchLibsFetched)
                }
                else {
                    dispatchLibsFetched();
                }
            }
        }).catch(err => {
            GlobalUtil.showToast('Save to library is not supported on your device', 'error');
            this.sendActivationAnalytic('libsfetch');
        })
    }

    createLibrary = (name, dispatch, dispatchLibsFetched) => {
        let libUrl = window.CONFIG_QA.servers.melville;
        let accessToken = "Bearer " + window.adobeIMS.getAccessToken();
        const header = {
            'Authorization': accessToken,
            'x-api-key': 'CCHomeWeb1'
        }
        libUrl = libUrl + '?invocation_mode=sync';
        axios.post(libUrl,{'name': name}, {
            headers: header
        }).then(resp => {
            dispatch(resp);
            dispatchLibsFetched();
        }).catch(err => {
            GlobalUtil.showToast('Save to library is not supported on your device', 'error');
            this.sendActivationAnalytic('libcreated');
        })
    }

    addAssettoLibrary = (asset, libID, libURN ,libtype, format) => {

        let libUrl = window.CONFIG_QA.servers.melville;
        if (libtype == 'public') {
            libUrl = libUrl + '/' + libID;
        }
        else {
            libUrl = libUrl + '/' + libURN;
        }
        let elementsUrl = libUrl + '/elements';
        libUrl = libUrl + '/representations/content';
        
        let accessToken = "Bearer " + window.adobeIMS.getAccessToken();
        const header = {
            'Authorization': accessToken,
            'x-api-key': 'CCHomeWeb1'
        }
        let data = new FormData();
        data.set('Representation-Data', `{\"type\": \"image/${format}\"}`);
        data.set('Representation-Content', asset);
        axios.post(libUrl, data, {
            headers: header
        }).then(resp => {
            const elementData = {
                'name': 'CCH-Pattern',
                'type': 'application/vnd.adobe.element.image+dcx',
                'representations': [resp.data],
                'client': {deviceId: "-", device: "-", app: "Quick-Actions-CCH"}
            }
            axios.post(elementsUrl, elementData ,{headers: header}).then((resp => {
                GlobalUtil.showToast('Successfully saved to library', 'success');
            })).catch(err => {
                GlobalUtil.showToast('Save to library is not supported on your device', 'error');
                this.sendActivationAnalytic('assetpost');
            })
        }).catch(err => {
            GlobalUtil.showToast('Save to library is not supported on your device', 'error');
            this.sendActivationAnalytic('assetpost');
        })
    }
}

export default new LibraryManager();
